class ActiveChargeTagsLimitExceededException extends Error {
  constructor(message) {
    super(message);
    this.name = 'ActiveChargeTagsLimitExceededException';
  }
}

export default ActiveChargeTagsLimitExceededException;
